import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  Menu,
  Tooltip,
  IconButton,
  CircularProgress,
  TextareaAutosize,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CommonDatePicker from "../../../Base/views/CommonDatePicker";
import { Add, Delete } from "@mui/icons-material";
import { useState } from "react";
import { makeStyles } from "@mui/styles";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { UploadTaxDeclarationProofHelper } from "../../helper/TaxDeclarationHelper";
import { convertBase64, getUserData } from "../../../Base/helper/baseFunctions";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
const useStyles = makeStyles((theme) => ({
  ActionSummaryStyle: {
    marginTop: "1%",
    minHeight: 50,
    maxHeight: 50,
    borderRadius: "10px 10px 0px 0px",
    "&.Mui-expanded": {
      minHeight: 50,
      maxHeight: 50,
      backgroundColor: "#f3edfd",
    },
  },
}));

const TDStep4 = ({
  handleInputChange,
  disableEdit = false,
  housePropertyObj,
  step4,
  setStep4,
  activeStep,
  setActiveStep,
  stepUpdate4,
  setStepUpdate4,
  toggleState,
  toggleDeclarationState,
  checkViewType,
  defaultValue,
  comments,
  setComments,
  fileProof,
  setFileProof,
  handleView,
  checkDeclarationStatus,
  regimeData,
}) => {
  const classes = useStyles();
  const maxHousePropertyList = 1;
  const [expanded, setExpanded] = useState(0);
  const [errors, setErrors] = useState([]);
  const [uploadStatus, setUploadStatus] = useState({});
  const [files, setFiles] = useState([]);
  const { show, disable_ap } = checkDeclarationStatus || {};
  const [numberOfHouseProperty, setNumberOfHouseProperty] = useState();
  function handleChange(event, index) {
    let newArr = [...step4];
    let item = newArr[index];
    item = { ...item, [event.target.name]: event.target.value };
    newArr[index] = item;
    setStep4(newArr);
  }
  const validate = () => {
    step4?.forEach((hp, i) => {
      const error = {};
      if (!hp.address) error.address = "Full Address is required";
      if (!hp.city) error.city = "City is required";
      if (!hp.status) error.status = "Status is required";
      if (!hp.loan_sanc_date)
        error.loan_sanc_date = "Load Sanctioned Date is required";
      if (!hp.lender_name) error.lender_name = "Lender Name is required";
      if (!hp.lender_type) error.lender_type = "Lender Type is required";
      if (!hp.possession_date)
        error.possession_date = "Possession Date is required";
      if (!hp.lender_pan) error.lender_pan = "PAN Lender is required";
      if (!hp.principal_amount)
        error.principal_amount = "Principal Amount is required";
      if (!hp.interest_amount)
        error.interest_amount = "Interest Amount is required";
      const temp = errors;
      temp[i] = error;
      setErrors([...temp]);
    });
    let hasError = [];
    errors.forEach((err) => {
      if (!Object.values(err).every((e) => e === "")) {
        hasError.push(true);
      }
    });
    return !hasError.includes(true);
  };

  const handleSaveHouseProperty = () => {
    if (checkViewType) {
      handleInputChange({ target: { name: "tds4", value: step4 } });
      if (regimeData?.regime !== "new_regime") {
        setActiveStep(activeStep + 1);
      } else {
        setActiveStep(activeStep + 2);
      }
    } else if (validate()) {
      handleInputChange({ target: { name: "tds4", value: step4 } });
      if (regimeData?.regime !== "new_regime") {
        setActiveStep(activeStep + 1);
      } else {
        setActiveStep(activeStep + 2);
      }
    }
  };

  const onAddHouseProperty = () => {
    setNumberOfHouseProperty(numberOfHouseProperty + 1);
    let objDetail = JSON.parse(JSON.stringify(housePropertyObj));
    setStep4(step4.concat(JSON.parse(JSON.stringify([objDetail]))));
  };

  const onRemoveHouseProperty = (e, index) => {
    const list = [...step4];
    list.splice(index, 1);
    setStep4([...list]);
    const errorList = [...errors];
    errorList.splice(index, 1);
    setErrors([...errorList]);
  };

  const handleUpdateChange = (event, housePropertyId) => {
    const newArr = stepUpdate4?.map((item) => {
      if (item?.house_property_id === housePropertyId) {
        return {
          ...item,
          [event.target.name]: event.target.value,
        };
      }
      return item;
    });
    setStepUpdate4(newArr);
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [selectedRow, setSelectedRow] = useState("false");

  const handleMenuClick = (event, rowKey) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(rowKey);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleFileUpload = async (event, name) => {
    const userData = getUserData();
    const file = event.target.files[0];
    if (file) {
      try {
        const allowedMimeTypes = [
          "application/pdf",
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ];
        if (!allowedMimeTypes.includes(file.type)) {
          toast.error(
            "Invalid File type. Accepted file types: .pdf, .doc, .docx",
            {
              duration: 2000,
            }
          );
          return;
        }
        const b64string = await convertBase64(file);

        const ext = file?.name?.split(".").at(-1).toLowerCase();
        const content_type = file.type;
        const filename =
          `${userData?.domain}/Payroll/EmployeeTDProof/` +
          uuidv4() +
          "." +
          name +
          "." +
          ext;

        setFiles((prev) => [
          ...prev,
          {
            b64string,
            filename,
            content_type,
            td_component: name,
          },
        ]);
        setUploadStatus((prev) => ({
          ...prev,
          [name]: "uploaded",
        }));
      } catch (error) {
        console.error("Error during file upload: ", error);
      }
    }
  };

  const handleDeselectFile = (name) => {
    setFiles((prev) => prev.filter((file) => file.td_component !== name));
    setUploadStatus((prev) => ({
      ...prev,
      [name]: null,
    }));
  };

  const handleSaveDocs = async (name, files) => {
    const fileToSave = files.find((file) => file?.td_component === name);
    setUploadStatus((prev) => ({
      ...prev,
      [name]: "loading",
    }));
    if (fileToSave) {
      try {
        const res = await UploadTaxDeclarationProofHelper({
          ...fileToSave,
          old_file_path: fileProof[fileToSave?.td_component],
        });

        if (res?.data?.statuscode === 200) {
          setFileProof((prev) => ({
            ...prev,
            [fileToSave?.td_component]: res?.data?.data?.[0]?.cloud_file,
          }));
        }
      } finally {
        setUploadStatus((prev) => ({
          ...prev,
          [name]: null,
        }));
        setFiles((prev) => prev.filter((file) => file.td_component !== name));
      }
    } else {
      setUploadStatus((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };
  return (
    <>
      <Box>
        {!disableEdit && (
          <Box display="flex" justifyContent={"space-between"}>
            <Typography variant="h6">
              Section 24 - Income / Loss on House Property, additional deduction
              under Section 80EE / 80EEA
            </Typography>
            {step4 && step4.length <= maxHousePropertyList && (
              <Box mb={1}>
                <Button
                  onClick={onAddHouseProperty}
                  variant="contained"
                  size="medium"
                  startIcon={<Add />}
                  className="mpl-primary-btn"
                  disabled={disable_ap}
                >
                  Add House Property &nbsp;&nbsp;
                </Button>
              </Box>
            )}
          </Box>
        )}
        {step4?.map((hp, i) => (
          <Accordion
            key={i}
            expanded={i === expanded}
            onChange={(e) =>
              i === expanded ? setExpanded("") : setExpanded(i)
            }
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className={classes.ActionSummaryStyle}
            >
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                <Typography variant="subtitle1" color={"inherit"}>
                  House Property {i + 1}
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: "3px", mr: "5px" }}>
                  {!disable_ap && (
                    <IconButton
                      aria-label="delete"
                      onClick={(e) => {
                        e.stopPropagation();
                        onRemoveHouseProperty(e, i);
                      }}
                    >
                      <Delete style={{ color: "#637381" }} />
                    </IconButton>
                  )}
                  {!disableEdit && (
                    <Box
                      display="flex"
                      justifyContent={"space-around"}
                      alignItems={"center"}
                    >
                      <IconButton
                        aria-label="actions"
                        aria-controls={open ? "proof-actions-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? "true" : undefined}
                        onClick={(e) =>{
                          e.stopPropagation();
                          handleMenuClick(e, `house_property_${i}`)}
                        }
                      >
                        <MoreVertIcon />
                      </IconButton>
                      <Menu
                        id="proof-actions-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={(e) =>{
                            e.stopPropagation();
                            handleMenuClose()
                          }}
                        MenuListProps={{
                          "aria-labelledby": "actions-button",
                        }}
                        sx={{
                          "& .MuiPaper-root": {
                            boxShadow: "none",
                          },
                        }}
                      >
                        <MenuItem>
                          {!checkViewType && (
                            <>
                              {!uploadStatus[selectedRow] && (
                                <Tooltip
                                  title={
                                    !toggleState
                                      ? "Proof upload window disabled"
                                      : "Proof Upload"
                                  }
                                >
                                  <Box
                                    display={"flex"}
                                    ml={"-8px"}
                                    alignItems={"center"}
                                  >
                                    <IconButton
                                      color="primary"
                                      component="label"
                                      disabled={
                                        !toggleState ||
                                        uploadStatus[selectedRow] === "uploaded"
                                      }
                                      sx={{
                                        "&:hover": {
                                          backgroundColor: "transparent", // remove hover background
                                        },
                                      }}
                                    >
                                      <CloudUploadIcon sx={{ mr: 1.5 }} />
                                      <Typography sx={{ fontSize: "0.9rem" }}>
                                        Proof Upload
                                      </Typography>
                                      <input
                                        type="file"
                                        hidden
                                        onChange={(event) =>{
                                          event.stopPropagation();
                                          handleFileUpload(event, selectedRow)}
                                        }
                                      />
                                    </IconButton>
                                  </Box>
                                </Tooltip>
                              )}

                              {uploadStatus[selectedRow] === "loading" ? (
                                <CircularProgress
                                  size={24}
                                  sx={{ display: "block", margin: "0 auto" }}
                                />
                              ) : uploadStatus[selectedRow] === "uploaded" ? (
                                <Box
                                  sx={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "space-around",
                                    alignItems: "center",
                                  }}
                                >
                                  <Tooltip title={"Save Proof"}>
                                    <IconButton
                                      sx={{ color: "primary" }}
                                      onClick={(e) =>{
                                        e.stopPropagation();
                                        handleSaveDocs(selectedRow, files)}
                                      }
                                    >
                                      <CheckCircleIcon color="primary" />
                                    </IconButton>
                                  </Tooltip>
                                  <Tooltip title={"Deselect Proof"}>
                                    <IconButton
                                      sx={{ color: "grey.500" }}
                                      onClick={(e) =>{
                                        e.stopPropagation();
                                        handleDeselectFile(selectedRow)}
                                      }
                                    >
                                      <CancelIcon />
                                    </IconButton>
                                  </Tooltip>
                                </Box>
                              ) : null}
                            </>
                          )}
                        </MenuItem>
                        <MenuItem
                          onClick={(e) =>{ 
                            e.stopPropagation();
                            handleView(fileProof[selectedRow])}}
                          disabled={
                            selectedRow === null ||
                            !fileProof[selectedRow] ||
                            !toggleState
                          }
                        >
                          <Tooltip
                            title={
                              !toggleState
                                ? ""
                                : !fileProof[selectedRow]
                                ? "No Attachment"
                                : "View Attachment"
                            }
                          >
                            <Box display="flex" alignItems="center" gap={0.5}>
                              <VisibilityIcon sx={{ mr: 1 }} />
                              <Typography sx={{ fontSize: "0.9rem" }}>
                                {!fileProof[selectedRow]
                                  ? "No Attachment"
                                  : "View Attachment"}
                              </Typography>
                            </Box>
                          </Tooltip>
                        </MenuItem>
                      </Menu>
                    </Box>
                  )}
                </Box>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container>
                <Grid item xs={12} sm={4} p={1}>
                  <TextField
                    required
                    autoFocus={true}
                    size="small"
                    autoComplete="first_name"
                    onChange={(event) => {
                      handleChange(event, i);
                    }}
                    name="address"
                    label="Full Address"
                    fullWidth
                    disabled={
                      disableEdit ||
                      toggleDeclarationState ||
                      checkViewType ||
                      disable_ap
                    }
                    sx={{
                      backgroundColor:
                        toggleDeclarationState || checkViewType || disable_ap
                          ? "#f3edfd"
                          : "#ffffff",
                      borderRadius: "5px",
                    }}
                    value={hp?.address || ""}
                    {...(errors[i] &&
                      errors[i].address && {
                        error: true,
                        helperText: errors[i].address,
                      })}
                  />
                </Grid>
                <Grid item xs={12} sm={4} p={1}>
                  <TextField
                    required
                    size="small"
                    autoComplete="city"
                    onChange={(event) => {
                      handleChange(event, i);
                    }}
                    name="city"
                    label="City"
                    fullWidth
                    disabled={
                      disableEdit ||
                      toggleDeclarationState ||
                      checkViewType ||
                      disable_ap
                    }
                    sx={{
                      backgroundColor:
                        toggleDeclarationState || checkViewType || disable_ap
                          ? "#f3edfd"
                          : "#ffffff",
                      borderRadius: "5px",
                    }}
                    value={hp?.city || ""}
                    {...(errors[i] &&
                      errors[i].city && {
                        error: true,
                        helperText: errors[i].city,
                      })}
                  />
                </Grid>
                <Grid item xs={12} sm={4} p={1}>
                  <TextField
                    required
                    size="small"
                    autoComplete="status"
                    onChange={(event) => {
                      handleChange(event, i);
                    }}
                    name="status"
                    label="Status"
                    fullWidth
                    disabled={
                      disableEdit ||
                      toggleDeclarationState ||
                      checkViewType ||
                      disable_ap
                    }
                    sx={{
                      backgroundColor:
                        toggleDeclarationState || checkViewType || disable_ap
                          ? "#f3edfd"
                          : "#ffffff",
                      borderRadius: "5px",
                    }}
                    value={hp?.status || ""}
                    {...(errors[i] &&
                      errors[i].status && {
                        error: true,
                        helperText: errors[i].status,
                      })}
                  />
                </Grid>
                <Grid item xs={12} sm={4} p={1}>
                  <FormControl fullWidth>
                    <CommonDatePicker
                      size="small"
                      name="loan_sanc_date"
                      label="Loan Sanctioned Date"
                      pickerType="date"
                      pickerFormat="dd/MM/yyyy"
                      DefaultDTvalue={hp?.loan_sanc_date}
                      disabled={
                        disableEdit ||
                        toggleDeclarationState ||
                        checkViewType ||
                        disable_ap
                      }
                      textFieldSx={{
                        backgroundColor:
                          toggleDeclarationState || checkViewType || disable_ap
                            ? "#f3edfd"
                            : "#ffffff",
                        borderRadius: "5px",
                      }}
                      handleChange={(value) =>
                        handleChange(
                          {
                            target: {
                              name: "loan_sanc_date",
                              value: `${
                                value?.getFullYear() +
                                "-" +
                                ("0" + (value.getMonth() + 1)).slice(-2) +
                                "-" +
                                ("0" + value.getDate()).slice(-2)
                              }`,
                            },
                          },
                          i
                        )
                      }
                      {...(errors[i] &&
                        errors[i].loan_sanc_date && {
                          error: true,
                          helperText: errors[i].loan_sanc_date,
                        })}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4} p={1}>
                  <TextField
                    size="small"
                    autoComplete="lender_name"
                    onChange={(event) => {
                      handleChange(event, i);
                    }}
                    name="lender_name"
                    label="Name of Lender"
                    required={true}
                    fullWidth
                    disabled={
                      disableEdit ||
                      toggleDeclarationState ||
                      checkViewType ||
                      disable_ap
                    }
                    sx={{
                      backgroundColor:
                        toggleDeclarationState || checkViewType || disable_ap
                          ? "#f3edfd"
                          : "#ffffff",
                      borderRadius: "5px",
                    }}
                    value={hp?.lender_name || ""}
                    {...(errors[i] &&
                      errors[i].lender_name && {
                        error: true,
                        helperText: errors[i].lender_name,
                      })}
                  />
                </Grid>
                <Grid item xs={12} sm={4} p={1}>
                  <FormControl
                    fullWidth
                    size="small"
                    error={errors[i]?.lender_type ? true : false}
                  >
                    <InputLabel id="lender-type-select-small" required={true}>
                      Type of Lender
                    </InputLabel>
                    <Select
                      labelId="lender-type-select-small"
                      name="lender_type"
                      id="lender-type-select-small"
                      value={hp?.lender_type || ""}
                      label="Type Of Lender"
                      disabled={
                        disableEdit ||
                        toggleDeclarationState ||
                        checkViewType ||
                        disable_ap
                      }
                      sx={{
                        backgroundColor:
                          toggleDeclarationState || checkViewType || disable_ap
                            ? "#f3edfd"
                            : "#ffffff",
                        borderRadius: "5px",
                      }}
                      onChange={(event) => {
                        handleChange(event, i);
                      }}
                    >
                      <MenuItem value="0">
                        <em>None</em>
                      </MenuItem>
                      <MenuItem value="Bank / Housing FI">
                        Bank / Housing FI
                      </MenuItem>
                      <MenuItem value="Employer">Employer</MenuItem>
                      <MenuItem value="Others">Others</MenuItem>
                    </Select>
                    <FormHelperText>
                      {errors[i]?.lender_type ? errors[i].lender_type : ""}
                    </FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4} p={1}>
                  <FormControl fullWidth>
                    <CommonDatePicker
                      size="small"
                      name="possession_date"
                      label="Possession Date"
                      pickerType="date"
                      required={true}
                      pickerFormat="dd/MM/yyyy"
                      DefaultDTvalue={hp?.possession_date}
                      disabled={
                        disableEdit ||
                        toggleDeclarationState ||
                        checkViewType ||
                        disable_ap
                      }
                      textFieldSx={{
                        backgroundColor:
                          toggleDeclarationState || checkViewType || disable_ap
                            ? "#f3edfd"
                            : "#ffffff",
                        borderRadius: "5px",
                      }}
                      handleChange={(value) =>
                        handleChange(
                          {
                            target: {
                              name: "possession_date",
                              value: `${
                                value?.getFullYear() +
                                "-" +
                                ("0" + (value.getMonth() + 1)).slice(-2) +
                                "-" +
                                ("0" + value.getDate()).slice(-2)
                              }`,
                            },
                          },
                          i
                        )
                      }
                      {...(errors[i] &&
                        errors[i].possession_date && {
                          error: true,
                          helperText: errors[i].possession_date,
                        })}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4} p={1}>
                  <TextField
                    size="small"
                    autoComplete="lender_pan"
                    onChange={(event) => {
                      handleChange(event, i);
                    }}
                    name="lender_pan"
                    required={true}
                    label="PAN Lender"
                    fullWidth
                    disabled={
                      disableEdit ||
                      toggleDeclarationState ||
                      checkViewType ||
                      disable_ap
                    }
                    sx={{
                      backgroundColor:
                        toggleDeclarationState || checkViewType || disable_ap
                          ? "#f3edfd"
                          : "#ffffff",
                      borderRadius: "5px",
                    }}
                    value={hp?.lender_pan || ""}
                    {...(errors[i] &&
                      errors[i].lender_pan && {
                        error: true,
                        helperText: errors[i].lender_pan,
                      })}
                  />
                </Grid>
                <Grid item xs={12} sm={4} p={1}>
                  <TextField
                    required
                    size="small"
                    autoComplete="principal_amount"
                    onChange={(e) => {
                        const rawValue = e.target.value.replace(/,/g, "");
                        const validNumberRegex = /^\d*\.?\d{0,2}$/;
                        if (rawValue === "" || validNumberRegex.test(rawValue)) {
                          handleChange({
                            target: {
                              name: "principal_amount",
                              value: +rawValue,
                            },
                          }, i)
                        }
                      }
                    }
                    name="principal_amount"
                    label="Principal Amount"
                    fullWidth
                    type="text"
                    disabled={
                      disableEdit ||
                      toggleDeclarationState ||
                      checkViewType ||
                      disable_ap
                    }
                    value={hp?.principal_amount ? Number(hp?.principal_amount).toLocaleString("en-IN") : ""}
                    sx={{
                      backgroundColor:
                        toggleDeclarationState || checkViewType || disable_ap
                          ? "#f3edfd"
                          : "#ffffff",
                      borderRadius: "5px",
                    }}
                    {...(errors[i] &&
                      errors[i].principal_amount && {
                        error: true,
                        helperText: errors[i].principal_amount,
                      })}
                  />
                </Grid>
                <Grid item xs={12} sm={4} p={1}>
                  <TextField
                    required
                    size="small"
                    autoComplete="interest_amount"
                    onChange={(e) => {
                        const rawValue = e.target.value.replace(/,/g, "");
                        const validNumberRegex = /^\d*\.?\d{0,2}$/;
                        if (rawValue === "" || validNumberRegex.test(rawValue)) {
                          handleChange({
                            target: {
                              name: "interest_amount",
                              value: +rawValue,
                            },
                          }, i)
                        }
                      }
                    }
                    name="interest_amount"
                    label="Interest Amount"
                    type="text"
                    fullWidth
                    disabled={
                      disableEdit ||
                      toggleDeclarationState ||
                      checkViewType ||
                      disable_ap
                    }
                    value={hp?.interest_amount ? Number(hp?.interest_amount).toLocaleString("en-IN") : ""}
                    sx={{
                      backgroundColor:
                        toggleDeclarationState || checkViewType || disable_ap
                          ? "#f3edfd"
                          : "#ffffff",
                      borderRadius: "5px",
                    }}
                    {...(errors[i] &&
                      errors[i].interest_amount && {
                        error: true,
                        helperText: errors[i].interest_amount,
                      })}
                  />
                </Grid>
              </Grid>
              <Box
                display={"flex"}
                justifyContent="space-between"
                alignItems={"center"}
              >
                <Typography p={1}>
                  <span style={{ fontWeight: 600 }}>Note:</span> Amount of
                  Principal repayment will be considered for deduction under
                  Section 80C (maximum of Rs. 1.50 lakhs)
                </Typography>
              </Box>
              {!disableEdit && (
                <>
                  <Typography variant="h6" p={1}>
                    Approved
                  </Typography>
                  <Grid container>
                    {(checkViewType || show) && (
                      <>
                        <Grid item xs={12} sm={6} md={4} p={1}>
                          <TextField
                            size="small"
                            type="text"
                            disabled={!checkViewType}
                            autoComplete="first_name"
                            onChange={(e) => {
                              const rawValue = e.target.value.replace(/,/g, "");
                              const validNumberRegex = /^\d*\.?\d{0,2}$/;
                              if (rawValue === "" || validNumberRegex.test(rawValue)) {
                                handleUpdateChange({
                                  target: {
                                    name: "principal_amount_approved",
                                    value: +rawValue,
                                  },
                                }, hp?.house_property_id)
                              }
                            }
                            }
                            name={`principal_amount_approved`}
                            label={"Principal Amount"}
                            placeholder="Enter Amount"
                            fullWidth
                            value={
                              stepUpdate4?.find(
                                (item) =>
                                  item?.house_property_id ===
                                  hp?.house_property_id
                              )?.principal_amount_approved ? Number(stepUpdate4?.find(
                                (item) =>
                                  item?.house_property_id ===
                                  hp?.house_property_id
                              )?.principal_amount_approved).toLocaleString("en-IN") : ""
                            }
                            onWheel={(e) => e.target.blur()}
                            sx={{
                              backgroundColor: !checkViewType
                                ? "#f3edfd"
                                : "#ffffff",
                              borderRadius: "7px",
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} p={1}>
                          <TextField
                            size="small"
                            type="text"
                            disabled={!checkViewType}
                            autoComplete="first_name"
                            onChange={(e) => {
                              const rawValue = e.target.value.replace(/,/g, "");
                              const validNumberRegex = /^\d*\.?\d{0,2}$/;
                              if (rawValue === "" || validNumberRegex.test(rawValue)) {
                                handleUpdateChange({
                                  target: {
                                    name: "interest_amount_approved",
                                    value: +rawValue,
                                  },
                                }, hp?.house_property_id)
                              }
                            }
                            }
                            name={`interest_amount_approved`}
                            label={"Interest Amount"}
                            placeholder="Enter Amount"
                            fullWidth
                            value={
                              stepUpdate4?.find(
                                (item) =>
                                  item.house_property_id ===
                                  hp?.house_property_id
                              )?.interest_amount_approved ? Number(stepUpdate4?.find(
                                (item) =>
                                  item.house_property_id ===
                                  hp?.house_property_id
                              )?.interest_amount_approved).toLocaleString("en-IN") : ""
                            }
                            onWheel={(e) => e.target.blur()}
                            sx={{
                              backgroundColor: !checkViewType
                                ? "#f3edfd"
                                : "#ffffff",
                              borderRadius: "7px",
                            }}
                          />
                        </Grid>
                      </>
                    )}

                    <Grid item xs={12} sm={6} md={4} p={1}>
                      <TextareaAutosize
                        minRows={2}
                        maxRows={3}
                        disabled={!checkViewType}
                        placeholder={
                          checkViewType ? "Enter Comment" : "Comment"
                        }
                        value={
                          stepUpdate4?.find(
                            (item) =>
                              item.house_property_id === hp?.house_property_id
                          )?.house_property_comment_approved || ""
                        }
                        name={`house_property_comment_approved`}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value.length <= 75) {
                            handleUpdateChange(e, hp?.house_property_id);
                          }
                        }}
                        style={{
                          width: "100%",
                          backgroundColor: checkViewType
                            ? "#ffffff"
                            : "#f3edfd",
                          borderRadius: "10px",
                          padding: "8px",
                          fontSize: "14px",
                          fontFamily: "inherit",
                          border: "1px solid #ccc",
                          resize: "none",
                        }}
                      />
                      {checkViewType && (
                        <Typography
                          variant="caption"
                          sx={{
                            display: "block",
                            textAlign: "right",
                            color: "#888",
                          }}
                        >
                          {stepUpdate4?.find(
                            (item) =>
                              item.house_property_id === hp?.house_property_id
                          )?.house_property_comment_approved?.length || 0}
                          /75
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                </>
              )}
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
      {!disableEdit && (
        <Box
          sx={{
            display: "flex",
            justifyContent:
              regimeData?.regime !== "new_regime" ? "space-between" : "end",
            bottom: 30,
          }}
        >
          {activeStep !== 0 && regimeData?.regime !== "new_regime" && (
            <Button
              sx={{ marginRight: "10px", mt: 5 }}
              type="submit"
              variant="outlined"
              size="medium"
              onClick={() => setActiveStep(activeStep - 1)}
            >
              Back
            </Button>
          )}
          {activeStep < 5 && (
            <Button
              sx={{ marginRight: "10px", mt: 5 }}
              size="medium"
              variant="contained"
              className="mpl-primary-btn"
              onClick={() => handleSaveHouseProperty()}
            >
              Next
            </Button>
          )}
        </Box>
      )}
    </>
  );
};

export default TDStep4;
